import { IonContent, IonPage, useIonViewWillEnter } from '@ionic/react'
import { useContext } from 'react'
import { RouteComponentProps } from 'react-router'
import styled from 'styled-components'
import { TextStyle } from '../../../components'
import { StoresContext } from '../../../provider/StoreProvider'

export const SignIn: React.FC<RouteComponentProps> = () => {
  const { commonStore, authStore } = useContext(StoresContext)

  useIonViewWillEnter(() => {
    commonStore.setShowTab(false)
  })

  const onSignIn = async (provider: 'google' | 'kakao' | 'naver') => {
    await authStore.oAuthSignIn(provider, '/home')
  }

  return (
    <>
      <IonPage>
        <IonContent>
          <SignInContainer>
            <TitleContainer>
              <ImageWrap>
                <img
                  src={'/img/thumbnail.svg'}
                  alt={'logo'}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null
                    currentTarget.src = '/img/thumbnail.svg'
                  }}
                />
              </ImageWrap>
              <TextStyle type={'r_13'}>{'서브 솔로건(ex:자산의 관점을 바꾸다.)'}</TextStyle>
              <TextStyle type={'b_20'}>{'메인 슬로건 & 서비스 이름'}</TextStyle>
            </TitleContainer>
            <BtnContainer type={'NAVER'} style={{ color: '#ffffff' }} onClick={() => onSignIn('naver')}>
              <img
                src={'img/symbol/LOGO-naver.svg'}
                alt={'-'}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null
                  currentTarget.src = '/img/thumbnail.svg'
                }}
              />
              <TextStyle type="b_15">네이버로 로그인</TextStyle>
              <div style={{ width: '24px' }} />
            </BtnContainer>
            <BtnContainer type={'KAKAO'} style={{ color: '#000000' }} onClick={() => onSignIn('kakao')}>
              <img
                src={'img/symbol/LOGO-kakao.svg'}
                alt={'-'}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null
                  currentTarget.src = '/img/thumbnail.svg'
                }}
              />
              <TextStyle type="b_15">카카오로 로그인</TextStyle>
              <div style={{ width: '24px' }} />
            </BtnContainer>
            <BtnContainer type={'GOOGLE'} onClick={() => onSignIn('google')}>
              <img
                src={'img/symbol/LOGO-google.svg'}
                alt={'-'}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null
                  currentTarget.src = '/img/thumbnail.svg'
                }}
              />
              <TextStyle type="b_15">구글로 로그인</TextStyle>
              <div style={{ width: '24px' }} />
            </BtnContainer>
          </SignInContainer>
        </IonContent>
      </IonPage>
    </>
  )
}

const SignInContainer = styled.div`
  padding: 0 20px;
`

const TitleContainer = styled.div`
  height: 391px;
  padding: 140px 0 80px;
  text-align: center;
  display: flex;
  flex-direction: column;
`

const ImageWrap = styled.div`
  height: 119px;
  img {
    padding: 8px 0 16px;
    width: 95px;
    border-radius: 10px;
  }
`
const BtnContainer = styled.div<{ type: 'NAVER' | 'KAKAO' | 'GOOGLE' }>`
  background-color: ${(props) => (props.type === 'NAVER' ? '#1ec800' : props.type === 'KAKAO' ? '#F9E000' : null)};
  ${(props) => (props.type === 'GOOGLE' ? 'border: solid 1px var(--ion-color-gray200)' : null)};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0;
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.type === 'NAVER' ? '#1bb400' : props.type === 'KAKAO' ? '#e1ca00' : 'var(--ion-color-gray100)'};
  }
  img {
    width: 24px;
  }
`
